import { FrontEndDeveloperIds, FrontEndDeveloperTitles, SkillTypeID } from "./enums";
import {
    Javascript,
    Python,
    Swift,
    CSharp,
    Sass,
    StyledComponents,
    Redux,
    ReduxSaga,
    Html,
    Recompose,
    Gsap,
    Bootstrap,
    MySQL,
    Laravel,
    Wordpress,
    NodeJs,
    ReactJs,
    Scrum,
    VueJs,
    Pyramid,
    Twig,
    Webpack,
    Yarn,
    Npm,
    Git,
    Valet,
    Grunt,
    CocoaPods,
    Bash,
    OhMyZshell,
    Docker,
    Sketch,
    Xcode,
    Parse,
    Swift2,
    AngularJs
} from "./SkillsData";
import { Education, Job } from "./types";

export const roles = [
    {
        id: FrontEndDeveloperIds.Web,
        title: FrontEndDeveloperTitles.Web
    },
    {
        id: FrontEndDeveloperIds.Mobile,
        title: FrontEndDeveloperTitles.Mobile
    }
];

export const skillCategory = [
    { category: "Frameworks\n& Templating", id: SkillTypeID.Frameworks },
    { category: "Programming Languages", id: SkillTypeID.Programming },
    { category: "Libraries", id: SkillTypeID.Libraries },
    { category: "Bundlers and others", id: SkillTypeID.Bundlers },
    { category: "Tools", id: SkillTypeID.Tools },
    { category: "Languages", id: SkillTypeID.Languages }
];

export const dataEducation: Education[] = [
    {
        id: 1,
        name: "KEA",
        title: "Computer Science",
        periodStart: 2013,
        periodEnd: 2016,
        link: "https://kea.dk/en/programmes/academy-profession-degree/computer-science"
    },
    {
        id: 2,
        name: "SESG",
        title: "Higher Commercial\nExamination Programme",
        periodStart: 2008,
        periodEnd: 2011,
        link: "https://sesg.dk/handelsgymnasiet-hhx/"
    }
];
export const jobs: Job[] = [
    {
        name: "Nuuday - MusikLab",
        roleId: FrontEndDeveloperIds.Web,
        data: {
            about:
                "Lorem Ipsum er ganske enkelt fyldtekst fra print- og typografiindustrien. Lorem Ipsum har været standard fyldtekst siden 1500-tallet, hvor en ukendt trykker sammensatte en tilfældig spalte for at trykke en bog til sammenligning af forskellige skrifttyper. Lorem Ipsum har ikke alene overlevet fem århundreder, men har også vundet indpas i elektronisk typografi uden væsentlige ændringer.",
            dates: {
                start: "February",
                startyear: 2020,
                end: "present",
                endyear: null
            },
            role: FrontEndDeveloperTitles.Web,
            description: ["Created a landing page for potential customers", "Maintainging ", "Been working on creating a new music client "],

            Skills: [ReactJs, Redux, Sass, Html, Scrum, Javascript, Webpack, Yarn, Git, Bash, OhMyZshell, Grunt, AngularJs, Bootstrap, Laravel, NodeJs]
        }
    },
    {
        name: "Dwarf",
        roleId: FrontEndDeveloperIds.Web,
        data: {
            about:
                "Lorem Ipsum er ganske enkelt fyldtekst fra print- og typografiindustrien. Lorem Ipsum har været standard fyldtekst siden 1500-tallet, hvor en ukendt trykker sammensatte en tilfældig spalte for at trykke en bog til sammenligning af forskellige skrifttyper. Lorem Ipsum har ikke alene overlevet fem århundreder, men har også vundet indpas i elektronisk typografi uden væsentlige ændringer.",
            dates: {
                start: "September",
                startyear: 2018,
                end: "February",
                endyear: 2020
            },
            role: FrontEndDeveloperTitles.Web,
            description: [
                "Lead the front-end development of the agency's second largest project to a successful launch, Increasing sales with a large percentage and adding more than 50 features across 3 applications to the client Comwell's website with ReactJs and Redux.",
                "Elevated design and implemented a paywall logic for TF Technologies' construction technology company customer-facing admin panel using Vanilla Javascript and Sass",
                "Building a multi-profile home inspections approval system for Danish Safety Technology Authority with ReactJs and Redux"
            ],

            Skills: [
                ReactJs,
                Redux,
                Sass,
                Html,
                Scrum,
                Javascript,
                Webpack,
                Yarn,
                Docker,
                Git,
                Bash,
                OhMyZshell,
                StyledComponents,
                Recompose,
                Sketch,
                Valet,
                Twig,
                Gsap,
                Grunt,
                VueJs,
                Bootstrap,
                Laravel,
                NodeJs
            ]
        }
    },
    {
        name: "Motosumo",
        roleId: FrontEndDeveloperIds.Web,
        data: {
            about:
                "Lorem Ipsum er ganske enkelt fyldtekst fra print- og typografiindustrien. Lorem Ipsum har været standard fyldtekst siden 1500-tallet, hvor en ukendt trykker sammensatte en tilfældig spalte for at trykke en bog til sammenligning af forskellige skrifttyper. Lorem Ipsum har ikke alene overlevet fem århundreder, men har også vundet indpas i elektronisk typografi uden væsentlige ændringer.",
            dates: {
                start: "November",
                startyear: 2017,
                end: "September",
                endyear: 2018
            },
            role: FrontEndDeveloperTitles.Web,
            description: [
                "Created the Motosumo.com home-page from scratch using Python, Pyramid and Chameleon",
                'Elevated the design and added new features to "Motosumo Bigscreen" web interface for spinning classes using ReactJs and Redux'
            ],
            Skills: [ReactJs, Redux, ReduxSaga, Sass, Html, Scrum, Javascript, Python, Webpack, Yarn, Npm, Docker, Git, Bash, OhMyZshell, Pyramid, Bootstrap, MySQL, NodeJs]
        }
    },
    {
        name: "Online Afdelingen",
        roleId: FrontEndDeveloperIds.Web,
        data: {
            about:
                "Lorem Ipsum er ganske enkelt fyldtekst fra print- og typografiindustrien. Lorem Ipsum har været standard fyldtekst siden 1500-tallet, hvor en ukendt trykker sammensatte en tilfældig spalte for at trykke en bog til sammenligning af forskellige skrifttyper. Lorem Ipsum har ikke alene overlevet fem århundreder, men har også vundet indpas i elektronisk typografi uden væsentlige ændringer.",
            dates: {
                start: "June",
                startyear: 2017,
                end: "October",
                endyear: 2017
            },
            role: FrontEndDeveloperTitles.Web,
            description: ["Created several websites for sale purposes by converting Sketch design to responsive HTML and Wordpress theme."],
            Skills: [ReactJs, Sass, Html, Javascript, Webpack, Yarn, Npm, Bash, OhMyZshell, Sketch, Bootstrap, NodeJs, Wordpress]
        }
    },
    {
        name: "Mustache",
        roleId: FrontEndDeveloperIds.Mobile,
        data: {
            about:
                "Lorem Ipsum er ganske enkelt fyldtekst fra print- og typografiindustrien. Lorem Ipsum har været standard fyldtekst siden 1500-tallet, hvor en ukendt trykker sammensatte en tilfældig spalte for at trykke en bog til sammenligning af forskellige skrifttyper. Lorem Ipsum har ikke alene overlevet fem århundreder, men har også vundet indpas i elektronisk typografi uden væsentlige ændringer.",
            dates: {
                start: "September",
                startyear: 2016,
                end: "November",
                endyear: 2016
            },
            role: FrontEndDeveloperTitles.Mobile,
            // description: ['Converted Sketch design to functioning iOS Mobile Application using Xcode and Swift 2.0.'],
            Skills: [Git, Bash, OhMyZshell, Sketch, Parse, Swift2, CocoaPods, Xcode]
        }
    },
    {
        name: "Workbook",
        roleId: FrontEndDeveloperIds.Mobile,
        data: {
            about:
                "Lorem Ipsum er ganske enkelt fyldtekst fra print- og typografiindustrien. Lorem Ipsum har været standard fyldtekst siden 1500-tallet, hvor en ukendt trykker sammensatte en tilfældig spalte for at trykke en bog til sammenligning af forskellige skrifttyper. Lorem Ipsum har ikke alene overlevet fem århundreder, men har også vundet indpas i elektronisk typografi uden væsentlige ændringer.",
            dates: {
                start: "August",
                startyear: 2015,
                end: "November",
                endyear: 2015
            },
            role: FrontEndDeveloperTitles.Mobile,
            // description: [
            //     'Built and designed an app that allowed Workbook users to upload multiple pictures and voice recordings simultaneously to their profile whiteboard',
            // ],
            Skills: [Git, Bash, OhMyZshell, MySQL, Swift, CSharp, CocoaPods, Xcode]
        }
    }
];
